export const supportedRunStates = [
  'READY',
  'WAITING',
  'RUNNING',
  'FAILED',
  'COMPLETED',
  'RESERVED',
  'ARCHIVED',
  'CANCELLED',
  'PAUSING',
  'PAUSED',
  'EVICTING',
];

export const aggregateRunStates = [
  'READY',
  'WAITING',
  'RESERVED',
  'RUNNING',
  'PAUSED',
  'FAILED',
  'CANCELLED',
  'COMPLETED',
  'ARCHIVED',
] as const;

export type AggregateRunState = (typeof aggregateRunStates)[number];

export function isAggregateRunState(state: string): state is AggregateRunState {
  return (aggregateRunStates as readonly string[]).includes(state);
}

// Non-terminal task states a workflow can contain — mirrors DASHBOARD_COUNT_STATES
// in the backend, which is also what the dashboard task counts report.
export const taskStateFilters = ['WAITING', 'READY', 'RESERVED', 'RUNNING', 'EVICTING', 'PAUSING', 'PAUSED'] as const;

export type TaskStateFilter = (typeof taskStateFilters)[number];

export function isTaskStateFilter(state: string): state is TaskStateFilter {
  return (taskStateFilters as readonly string[]).includes(state);
}

// Days back the workflow listings look, on updated_on. The task-state filter
// cannot be served by an index, so the window is what keeps it off the whole
// tenant — and the task counts carry the same bound so the two agree.
export const ACTIVITY_WINDOWS = ['7', '30', '90', ''] as const;

export type ActivityWindow = (typeof ACTIVITY_WINDOWS)[number];

export const DEFAULT_ACTIVITY_WINDOW: ActivityWindow = '7';

type RunState = (typeof supportedRunStates)[number];

export default RunState;
